module.exports = __webpack_public_path__ + "static/calculator-4a1971939a6a1c4f9227fc49f5753cbf.png";